import { lazy } from 'react'
import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom'
import { NavigateExternal } from '@dhl/utils'
import { externalPaths, paths } from './paths'
import { Page } from '~/components/Page'
import { getConfig, isFeatureEnabled } from './config'

const DashboardRoutes = lazy(() => import('~/dashboard/Routes').then((module) => ({ default: module.DashboardRoutes })))
const LocatorRoutes = lazy(() => import('~/locator/Routes').then((module) => ({ default: module.LocatorRoutes })))
const MaintenancePage = lazy(() => import('@dhl/maintenance').then((module) => ({ default: module.MaintenancePage })))
const MoreRoutes = lazy(() => import('~/more/Routes').then((module) => ({ default: module.MoreRoutes })))
const PiecesRoutes = lazy(() => import('~/pieces/Routes').then((module) => ({ default: module.PiecesRoutes })))
const TrackTraceRoutes = lazy(() =>
  import('~/tracktrace/Routes').then((module) => ({ default: module.TrackTraceRoutes }))
)
const C2CRoutes = lazy(() => import('~/c2c/view/Routes').then((module) => ({ default: module.C2CRoutes })))

export const Routes = () => {
  const { catchAllLink } = getConfig()
  const maintenanceModeEnabled = isFeatureEnabled('maintenance')

  if (maintenanceModeEnabled) {
    return (
      <Page>
        <MaintenancePage />
      </Page>
    )
  }

  return (
    <RouterRoutes>
      {isFeatureEnabled('dashboard') && (
        <Route path={paths.DASHBOARD}>
          <Route index path="*" element={<DashboardRoutes />} />
        </Route>
      )}

      {isFeatureEnabled('receive', 'send') && (
        <Route path={paths.SHIPMENTS}>
          <Route index path="*" element={<PiecesRoutes />} />
        </Route>
      )}

      {isFeatureEnabled('more') && (
        <Route path={paths.MORE}>
          <Route index path="*" element={<MoreRoutes />} />
        </Route>
      )}

      {isFeatureEnabled('chat') && <Route path={`${paths.TRACKTRACE}/chat/:barcode`} element={<TrackTraceRoutes />} />}

      {isFeatureEnabled('trackTrace') && <Route path={`${paths.TRACKTRACE}/*`} element={<TrackTraceRoutes />} />}

      <Route path={paths.C2C}>
        <Route index path="*" element={<C2CRoutes />} />
      </Route>

      {isFeatureEnabled('locator') && (
        <Route path={paths.LOCATOR}>
          <Route index path="*" element={<LocatorRoutes />} />
        </Route>
      )}

      {Object.values(externalPaths).map((path) => (
        <Route key={path} path={path} element={<NavigateExternal to={path} />} />
      ))}

      {isFeatureEnabled('dashboard') && <Route index path="*" element={<Navigate to={`/${paths.DASHBOARD}`} />} />}

      <Route
        path="*"
        element={catchAllLink.startsWith('/') ? <Navigate to={catchAllLink} /> : <NavigateExternal to={catchAllLink} />}
      />
    </RouterRoutes>
  )
}
